import * as yup from 'yup';

const individual_general_information_validation_schema = yup.object().shape({

  areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany: yup
    .boolean()
    .required('this_field_is_required'),

  describeNameOfTheCompany: yup
    .string()
    .when('areYouAMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', {
      is: true,
      then: (schema) =>
        schema.required('please_describe_name_of_country'),
      otherwise: (schema) => schema.notRequired(),
    }),

  areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany: yup
    .boolean()
    .required('this_field_is_required'),

  describeYourRelationToTheBoardOfMember: yup
    .string()
    .when('areYouRelatedTotalMemberOfTheBoardOfDirectorsAnAuditCommitteeMemberOrASeniorExecutiveAtAPubliclyListedCompany', {
      is: true,
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  areYouEntrustedWithAProminentPosition: yup
    .boolean()
    .required('this_field_is_required'),

  pleaseSpecifyYourFunctionOrPositionAndYourInstitution: yup
    .string()
    .when('areYouEntrustedWithAProminentPosition', {
      is: true,
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition: yup
    .boolean()
    .required('this_field_is_required'),

  pleaseDescribeYourRelationshipOrAssociationAndTheirInstitution: yup
    .string()
    .when('doYouHaveARelationshipOrAssociationWithAPersonWhoIsInAProminentPosition', {
      is: true,
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  willYouBeTheBeneficialOwnerOfThisAccount: yup
    .boolean()
    .required('this_field_is_required'),

  nameOfTheBeneficialOwner: yup
    .string()
    .when('willYouBeTheBeneficialOwnerOfThisAccount', {
      is: true,
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),

  beneficiaryIdNumber: yup
    .number()
    .when('willYouBeTheBeneficialOwnerOfThisAccount', {
      is: true,
      then: (schema) =>
        schema.required('please_specify'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default individual_general_information_validation_schema;
